/*
 * Арифметика календарных дат в формате ISO (2026-10-15) - как их отдаёт API и
 * поле <input type="date">. Считаем в UTC: местное время на переходе часов
 * сдвинуло бы день.
 */

/** Сегодня по местному времени, в том же формате: срок клиент считает по своему календарю. */
export const today = (): string => {
  const now = new Date();

  return [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-');
};

/** Сколько дней от from до to; to позже - больше нуля. */
export const daysBetween = (from: string, to: string): number =>
  Math.round((Date.parse(to) - Date.parse(from)) / 86_400_000);

/** Дата через days дней после isoDate, в том же формате. */
export const addDays = (isoDate: string, days: number): string => {
  const [year = 0, month = 1, day = 1] = isoDate.split('-').map(Number);

  return new Date(Date.UTC(year, month - 1, day + days))
    .toISOString()
    .slice(0, 10);
};

/** Дата через months месяцев после isoDate; нет такого дня в месяце - последний день месяца. */
export const addMonths = (isoDate: string, months: number): string => {
  const [year = 0, month = 1, day = 1] = isoDate.split('-').map(Number);
  const lastDay = new Date(
    Date.UTC(year, month - 1 + months + 1, 0),
  ).getUTCDate();

  return new Date(Date.UTC(year, month - 1 + months, Math.min(day, lastDay)))
    .toISOString()
    .slice(0, 10);
};
